import React from 'react'
import { lower } from 'change-case'
import { compose } from 'recompose'
import { Radio } from 'semantic-ui-react'
import { SwitchContainer } from '../styled'

const SwitchInput = (props) => {
  const { label, input, style, editable, specialOnChange } = props
  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>{label}</span>
      <div className='fieldInput'>
        <SwitchContainer>
          <span>No</span>
          <div className='inputContent'>
            <Radio
              disabled={editable === false}
              toggle
              checked={
                typeof(input.value) === 'boolean' ? 
                  input.value : 
                  ((typeof(input.value) === 'string' && lower(input.value)) === 'true' ? true : false)}
              onChange={(event, data) => {
                input.onChange(data.checked)
                if (specialOnChange) {
                  specialOnChange(data.checked)
                }
              }}
            />
          </div>
          <span>Yes</span>
        </SwitchContainer>
      </div>
    </div>
  )
}

export default compose()(SwitchInput)